import { useDayUi } from '../features/day/dayUiStore';
import { useGestureCounts } from '../features/day/gestureCount';
import { leaveLocalMode } from './localMode';
import { removeStorage } from './safeStorage';
import { StorageKey } from './storageKeys';

/**
 * Reset what depends on the local data after it was deleted (the data itself is deleted by
 * `store.clearAllData`): the quick-mark state, the gesture learning counters, the first-run flag (a cleared
 * device starts over with the first-run screen) the memory of the space the data belonged to and the local-mode choice.
 */
export function resetDeviceAfterClear(): void {
  useDayUi.getState().quickMarkExit();
  removeStorage(StorageKey.GestureCount);
  useGestureCounts.getState().refresh();
  removeStorage(StorageKey.Onboarded);
  removeStorage(StorageKey.LastSpaceId);
  // A cleared device has no data to keep local: it starts at the welcome page again.
  leaveLocalMode();
}
